<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">{{name}}添加内容项</h1>
            <div class="cnt-area">
                <el-input placeholder="可输入内容项ID或者关键词查询" v-model="keyword" @input="getCntList"></el-input>
                <div class="result-list" v-if="contentList.length">
                     <el-radio-group v-if="body_type!=3" v-model="title">
                        <el-radio  v-for="item in contentList" :key="item.id" :label="item.body" :value="item.id" >{{item.body}}</el-radio>
                    </el-radio-group>
                      <el-checkbox-group v-else v-model="checkList">
                        <el-checkbox  v-for="item in contentList" :key="item.id" :label="item.body" :value="item.id" >{{item.body}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div  class="result-list" v-else>
                    <p>当前文章类型暂无内容</p>
                </div>
            </div>
                
            <div class="form-button">
                <el-button type="primary" @click="submit">确 认</el-button>
                <el-button type="info" @click.stop.prevent="hide">取 消</el-button>
            </div>
        </div>
    </PopoverRight>
</template>

<script>
    import { getCntList } from '@/service/newsModel'
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "baikeAdd",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        
        data () {
         
            return {
                showTop:false,
                title:"",
                body_type:'',
                typeId:'',
                name:'',
                keyword:"",
                contentList:[],
                checkList:[],
            }
        },
        mounted(){
            
        },
        methods : {
            open (type,title,typeId) {
                this.name = title;
                this.body_type = type;
                this.typeId = typeId;
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
                this.getCntList();
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.keyword='';
                this.title='';
                this.checkList=[];
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            async getCntList(){
                let query={
                    'body_type':this.body_type,
                    'type':this.typeId
                }
                if(!!this.keyword){
                    query.keyword = this.keyword
                }
                await getCntList(query).then((data) => {
                    this.contentList = data.data
                })

            },
            submit() {
                const query = {};
                query.body_type = this.body_type
                if(this.body_type == 3){
                    query.body = this.checkList;
                    this.callback(query)
                }else{
                    query.body = this.title;
                    this.callback(query)
                }
                this.hide();
            },
        },
    }
</script>

<style scoped>
    .cnt-area{
        margin-top:40px;
    }
    .result-list{
        margin-top:30px;
        width: 100%;
        max-height: 500px;
        overflow: auto;
        border:1px solid #ddd;
        padding:20px;
        box-sizing: border-box;
    }
    .result-list .el-radio{
        display: block;
        margin-bottom:20px;
        font-size:16px;
        color:#000;
    }
    .result-list .el-checkbox{
         display: block;
        margin-bottom:20px;
        font-size:16px;
        color:#000;
    }
</style>
